import useAsyncResultIdle from "../../hooks/useAsyncResultIdle"
import {
	ApplicationFormVersion,
	isApplicationFormV2,
	previewApplicationForm,
	PreviewApplicationFormPrefill,
} from "../../resources/applicationForm"
import React, {useEffect, useState} from "react"
import {AsyncResultModal} from "../../components/AsyncResultModal/AsyncResultModal"

interface Props {
	close: () => void
	accessToken: string
	applicationFormVersion: ApplicationFormVersion
}

export function ApplicationFormPreviewModal({close, accessToken, applicationFormVersion}: Props) {
	const [previewState, preview] = useAsyncResultIdle(previewApplicationForm)
	const [previewPrefillType, setPreviewPrefillType] = useState<PreviewApplicationFormPrefill>("NoPrefill")
	const [whiteLabelThemeId, setWhiteLabelThemeId] = useState<string>("")
	const [lendingProgramId, setLendingProgramId] = useState<string>("")

	useEffect(() => {
		if (previewState.isOk()) {
			if (isApplicationFormV2(previewState.value)) {
				window.open(previewState.value.links.related.href, "_blank")
			} else {
				window.open(previewState.value.attributes.url, "_blank")
			}
		}
	}, [previewState])

	return (
		<AsyncResultModal
			title="Preview Application Form"
			close={close}
			state={previewState}
			onSubmit={() =>
				preview({
					accessToken,
					prefillType: previewPrefillType,
					version: applicationFormVersion,
					whiteLabelThemeId,
					lendingProgramId,
				})
			}
			onSuccess={() => close()}
			successText="Preview"
			buttonText="Preview"
			buttonClassname="button is-info"
			errorToText={(err) => (err.errors ? err.errors[0].title : "An unexpected error has occurred")}
		>
			<div className="control">
				{"Form Prefill: "}
				<select
					data-test={"prefill-select"}
					value={previewPrefillType}
					onChange={(e) => setPreviewPrefillType(e.target.value as PreviewApplicationFormPrefill)}
				>
					<option key="NoPrefill" value="NoPrefill">
						No Prefill
					</option>
					<option key="PrefillIndividual" value="PrefillIndividual">
						Prefill Individual
					</option>
					<option key="PrefillSoleProp" value="PrefillSoleProp">
						Prefill Sole Prop
					</option>
					{applicationFormVersion == ApplicationFormVersion.V2 ? (
						<>
							<option key="PrefillSingleMemberBusiness" value="PrefillSingleMemberBusiness">
								Prefill Single - Member Business
							</option>
							<option key="PrefillMultipleMemberBusiness" value="PrefillMultipleMemberBusiness">
								Prefill Multiple - Member Business
							</option>
						</>
					) : (
						<option key="PrefillBusiness" value="PrefillBusiness">
							Prefill Business
						</option>
					)}
				</select>
			</div>
			{applicationFormVersion == ApplicationFormVersion.V2 && (
				<>
					<div className="control">
						{"White-Label Theme ID: "}
						<input
							type="text"
							pattern="^\d+$"
							value={whiteLabelThemeId}
							onChange={(e) => setWhiteLabelThemeId(e.target.value)}
						/>
					</div>
					<div className="control">
						{"Lending Program ID: "}
						<input
							type="text"
							pattern="^\d+$"
							value={lendingProgramId}
							onChange={(e) => setLendingProgramId(e.target.value)}
						/>
					</div>
				</>
			)}

			<div></div>
			<div className="has-text-grey-light mt-2">Note: Please make sure all changes are saved before preview</div>
		</AsyncResultModal>
	)
}
